import { useEffect, useState } from 'react';
const useScrollCompensation = ()=>{
    const [sx, setSx] = useState({});
    useEffect(()=>{
        const observer = new MutationObserver(()=>{
            const bodyPadding = window.getComputedStyle(document.body).paddingRight;
            if (bodyPadding === '0px') {
                setSx({});
            } else {
                setSx({
                    paddingRight: bodyPadding
                });
            }
        });
        observer.observe(document.body, {
            attributes: true,
            attributeFilter: [
                'style'
            ]
        });
        return ()=>{
            observer.disconnect();
            setSx({});
        };
    }, []);
    return sx;
};
export default useScrollCompensation;
